import { render, staticRenderFns } from "./Coachs.vue?vue&type=template&id=71a36c54&scoped=true&"
import script from "./Coachs.vue?vue&type=script&lang=js&"
export * from "./Coachs.vue?vue&type=script&lang=js&"
import style0 from "./Coachs.vue?vue&type=style&index=0&id=71a36c54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a36c54",
  null
  
)

export default component.exports